import { selectFromCreateServiceAccountDto } from '../../models';

export default selectFromCreateServiceAccountDto()
  .token
  .expiresOn
  .toString();
